<template>
  <el-dialog
    :title="dialogTitle"
    :visible="true"
    width="1300px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="() => handleClose(false, form.content)"
  >
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="资讯名称" required>
        <el-input
          v-model="form.name"
          placeholder="请输入资讯名称"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="资讯导语">
        <el-input
          v-model="form.infoIntroduce"
          placeholder="请输入资讯导语"
          maxlength="100"
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item label="资讯封面">
        <div class="img-control">
          <div class="img-box" v-if="form.img">
            <img :src="form.img" alt="封面图片" />
            <span class="clear-img" @click="handleClearImg">X</span>
          </div>
          <Upload ref="uploadRef" :text="'，图片尺寸为160px*92px'" v-model="form.img" />
        </div>
      </el-form-item>
      <el-form-item label="资讯标题" required>
        <QuillEditor2 :maxlength="65" v-model="form.title" placeholder="请输入资讯标题" />
      </el-form-item>
      <el-form-item label="资讯来源" required>
        <el-input
          v-model="form.infoSource"
          placeholder="请输入资讯来源"
          maxlength="48"
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item label="发布时间" required>
        <el-date-picker
          v-model="form.publishTime"
          type="datetime"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="资讯内容" required>
        <QuillEditor
          ref="editorRef"
          v-model="form.content"
        />
      </el-form-item>
      <el-form-item label="上传附件">
        <UploadFile
          ref="uploadFileRef"
          :value="form.attachFileList"
          v-model="form.attachFileList"
          :handleRemove="handleRemoveFile"
        />
      </el-form-item>
    </el-form>
    <div class="write-footer">
      <el-button size="small" type="primary" @click="handlePreview(true)">
        预览
      </el-button>
      <el-button class="search-but1" size="small" @click="handleClose(false, form.content)">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="handleSubmit">
        确认
      </el-button>
    </div>
    <InformationPreview
      v-if="previewFlag"
      :handleClose="handlePreview"
      :viewData="form"
    />
  </el-dialog>
</template>
<script>
import QuillEditor from '../../components/QuillEditor/index.vue'
import QuillEditor2 from '../../components/QuillEditor/index2.vue'
import Upload from './module/upload.vue'
import UploadFile from './module/uploadFile.vue'
import * as API from '@/api/api'
import InformationPreview from './preview.vue'


export default {
  props: ['dialogTitle', 'handleClose', 'defaultData', 'typeId', 'close'],
  name: 'InformationWrite',
  components: { Upload, QuillEditor, QuillEditor2, UploadFile, InformationPreview },
  data() {
    return {
      form: {
        ...this.defaultData,
        attachFileList: []
      },
      previewFlag: false
    }
  },
  created() {
    this.getAttachFileList()
  },
  methods: {
    async getAttachFileList() {
      const { id } = this.defaultData
      if (!id) return
      try {
        const res = await API.getTalentServeFileList({ id })
        const { code, data = [] } = res
        if (code === 0) {
          this.$set(this.form, 'attachFileList', data)
        }
      } catch (error) {}
    },
    async handleSubmit() {
      const { dialogTitle, typeId, form } = this
      const { name, title, infoSource, publishTime, content } = form
      if (
        !(name && title && infoSource && publishTime && content)
      ) {
        this.$message.warning('请填写必填项，再继续保存')
        return
      }
      if (title === '<p><br></p>' || content === '<p><br></p>') {
        return this.$message.warning('请填写必填项，再继续保存')
      }
      try {
        const data = {
          type: typeId,
          ...form
        }
        const { code } = await API[
          dialogTitle === '新建资讯' ? 'addTalentServe' : 'updateTalentServe'
        ](data)
        if (code === 0) {
          this.$message.success('保存成功')
          this.close(dialogTitle === '新建资讯' ? 'reset' : 'update')
        }
      } catch (error) {}
    },
    handleClearImg() {
      this.$set(this.form, 'img', '')
    },
    handleRemoveFile(file, fileList) {
      // 新上传回传的数据没有uid
      const { attachFileList } = this.form
      const { uid, name } = file
      let index = null
      // 查找是否源表单中有删除文件相同的文件uid
      for (let i = 0; i < attachFileList.length; i++) {
        if (uid === attachFileList[i].uid) {
          index = i
          break
        }
      }
      if (index !== null) {
        attachFileList.splice(index, 1)
      } else {
        // 存在缺陷相同文件的bug
        this.$set(
          this.form,
          'attachFileList',
          attachFileList.filter((item) => item.name !== name)
        )
      }
    },
    handlePreview(bool) {
      if (bool) {
        const { name, title, infoSource, publishTime, content } =
          this.form
        if (
          !(name && title && infoSource && publishTime && content)
        ) {
          this.$message.warning('请填写必填项，再预览')
          return
        }
      }
      this.previewFlag = bool
    }
  }
}
</script>
<style lang="scss" scoped>
.text-red {
  color: red;
}
.img-control {
  display: flex;
  .img-box {
    position: relative;
    margin-right: 10px;
    > img {
      width: 360px;
      height: 180px;
    }
    .clear-img {
      position: absolute;
      top: 0;
      right: 0;
      display: block;
      border: 1px solid #333;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.write-footer {
  text-align: right;
}
</style>
